import styled from "styled-components"
import DataTable_s from "components/table/data-table-styles"
import { Colors } from 'styles/app-styles'

export const TMOC_s = styled.div`
  .p-paginator {
    bottom: 0px;
  }
`

export const TMOCTable_s = styled(DataTable_s)`
  border-spacing: 15px;

  table.p-datatable-scrollable-header-table, table.p-datatable-scrollable-body-table {
    width: auto;
  }

  table.p-datatable-scrollable-body-table {
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  }

  .p-datatable-thead > tr {
    height: 30px;
  }

  // Hide filter input row
  .p-datatable-unfrozen-view thead.p-datatable-thead > tr:last-child {
    display: none;
  }

  .systemImmutable-row {
    background: ${Colors.athensGrey} !important;
  }
  .system-row .system-disabled {
    background: ${Colors.athensGrey};
  }

  .systemImmutable-row, .system-row .system-disabled {
    input.p-inputtext:not(.has-errors) {
      background: inherit;
      border: none !important;
    }
  }

  .carousel-multi-row {
    > div:nth-child(2) > input {
      width: 135px;
    }
  }

  input[data-field="amt"] {
    width: 135px;
  }

  .static-year-input {
    width: 45px;
  }

  .amt-type-field {
    width: 250px;
  }

  .new-field {
    width: 130px !important;
  }

  .renewal-field {
    width: 130px !important;
  }

`
